const { getElement, getElements } = window.BAO.Utils

class SlidingText extends window.BAO.CustomElement() {
  constructor() {
    super()
    this.interval = parseInt(this.dataset.interval) || 3000
    this.mediaQuery = window.matchMedia('(min-width: 901px)')
    this._onItemsUpdated = this._onItemsUpdated.bind(this)

    this.selectors = {
      visible: '.is-visible'
    }
  }

  connectedCallback() {
    if (!this.mediaQuery.matches) return

    if (!this.els.wrapper.element) return

    this._refreshWords()
    if (this.words.length < 2) return

    this.timer = setInterval(() => this._switchWord(), this.interval)

    window.addEventListener('slidingText:updated', this._onItemsUpdated)
  }

  disconnectedCallback() {
    clearInterval(this.timer)
    window.removeEventListener('slidingText:updated', this._onItemsUpdated)
  }

  _refreshWords() {
    this.words = this.els.item.elements
  }

  _onItemsUpdated() {
    this._refreshWords()

    if (this.words.length < 2) {
      clearInterval(this.timer)
      this.timer = null

      const firstItem = this.words[0]
      if (firstItem) {
        firstItem.classList.add('is-visible')
        firstItem.classList.remove('is-hidden', 'slide-out', 'slide-in')
        firstItem.style = ''
      }
    } else {
      if (!getElement(this.selectors.visible, { context: this.wrapper })) {
        
        const firstItem = this.words[0]
        firstItem.classList.add('is-visible')
        firstItem.classList.remove('is-hidden', 'slide-out', 'slide-in')
        firstItem.style = ''
      }

      if (!this.timer) {
        this.timer = setInterval(() => this._switchWord(), this.interval)
      }
    }
  }

  _switchWord() {
    this._refreshWords()
    if (this.words.length < 2) return

    const current = getElement(this.selectors.visible, { context: this.wrapper }) || this.words[0]
    let next = current.nextElementSibling || this.words[0]

    if (current === next) return

    current.removeAttribute('style')

    current.classList.remove('is-visible', 'slide-in')
    current.classList.add('slide-out')

    next.classList.remove('is-hidden', 'slide-out')
    next.style.transform = 'translateY(100%)'
    next.style.zIndex = '3'

    setTimeout(() => {
      next.classList.add('is-visible', 'slide-in')
    }, 150)

    setTimeout(() => {
      current.classList.remove('slide-out')
      current.classList.add('is-hidden')
      next.classList.remove('slide-in')
      next.style.opacity = ''
      next.style.transform = ''
      next.style.zIndex = ''
    }, 1000)
  }
}

if (!customElements.get('sliding-text')) {
  customElements.define('sliding-text', SlidingText)
}